import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardImage from '../assets/timerCard-gray.png';
import CardImageOnHover from '../assets/timerCard.png';
import PropTypes from 'prop-types';

//images
import PlayIcon from '../assets/play.svg';
import Counter from './Counter';

export default function TimerCard(props) {
  const [hover, setHover] = useState(false);
  return (
    <Card
      className="card timer-card"
      key={props.index}
      onClick={() => {
        props.handler ? props.handler() : {};
      }}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      style={
        props.bottomColor
          ? { borderBottom: `7px solid ${props.bottomColor}` }
          : {}
      }
    >
      <div
        className={
          props.variant === 'smallcard'
            ? 'flex flex-space-between height-100 width-100'
            : 'flex-column flex-space-between height-100 width-100'
        }
      >
        <CardContent className="card-header">
          <p className="card-title">
            <span className="sub">{props.subject}</span>
            <span className="date">{props.dateTime}</span>
          </p>
          <p className="subject-title">{props.topic}</p>
        </CardContent>
        <div>
          <div className="card-background">
            <img
              className="card-image"
              src={hover ? CardImageOnHover : CardImage}
              alt="card image"
            />
          </div>

          <CardActions className="card-action">
            <span className="play-icon">
              <img src={PlayIcon} />
            </span>
            <p>
              <span className="action-title">{props.start}</span>
            </p>
            <Counter
              initialTime={props.initialTime}
              callback={props.callback}
            />
          </CardActions>
        </div>
      </div>
    </Card>
  );
}

TimerCard.defaultProps = {
  variant: 'fullcard'
};

TimerCard.propTypes = {
  index: PropTypes.string,
  subject: PropTypes.string,
  dateTime: PropTypes.string,
  topic: PropTypes.string,
  start: PropTypes.string,
  initialTime: PropTypes.number,
  handler: PropTypes.func,
  callback: PropTypes.func,
  bottomColor: PropTypes.string,
  variant: PropTypes.string
};
